import type { ReactElement } from 'react'
import styled from 'styled-components'

import { ImageTitleLayout } from '@/components/layout'
import { CompanyLinks } from '@/components/layouts/Company/CompanyLinks'
import { Head } from '@/components/layouts/Head'

export const CompanyPage = () => {
  return (
    <>
      <CompanyMain>
        <CompanyLinks padding={{ pc: '0 0', sp: '0 0' }} />
      </CompanyMain>
    </>
  )
}

CompanyPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '企業情報', path: '' },
  ]
  return (
    <>
      <Head
        title="企業情報"
        description="トライアルホールディングスの企業情報を掲載しています。"
        ogp={{ url: 'company/' }}
      />
      <ImageTitleLayout
        title="Corporate Information"
        subTitle="企業情報"
        imgUrl="/images/top-company.webp"
        breadCrumbs={breadCrumbs}
        isRequiredBackground
      >
        {page}
      </ImageTitleLayout>
    </>
  )
}

const CompanyMain = styled.div`
  width: 1040px;
  margin: 0 auto;
  padding: 98px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 70px;
  }
`
